import Button from "../../../Custom/Button/Button";

const LatinicaWarningModal = ({ handleCancel }) => {
  return (
    <div
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "40%",
          borderRadius: "10px",
          padding: "20px"
        }}
      >
        <div
          style={{
            marginBottom: "40px",
            textAlign: "center",
            fontSize: "18px"
          }}
        >
          Користите искључиво ћирилицу!
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div
            onClick={handleCancel}
            style={{ width: "100px", height: "40px" }}
          >
            <Button activation={true}>У реду</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatinicaWarningModal;
